
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";

  import SUBSCRIPTION_GET_NOTIFICATIONS from "@/apollo/notifications/SubscriptionGetNotifications.gql";
  import GET_NOTIFICATIONS_COUNT from "@/apollo/notifications/GetNotificationsCount.gql";

  import NotificationItem from "@/components/notification/NotificationItem.vue";
  import MarkAllAsRead from "@/components/notification/MarkAllAsRead.vue";
  import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
  import PopUpContainer from "@/components/common/PopUpContainer.vue";

  import { Notification } from "@/generated/graphql";
  import RouteNames from "@/entities/RouteNames";
  import { SHOW_ALL_NOTIFICATIONS } from "@/entities/Events";

  @Component({
    components: {
      NotificationItem,
      MarkAllAsRead,
      LoadingOverlay,
      PopUpContainer,
    },
    apollo: {
      oldNotificationsCount: {
        query: GET_NOTIFICATIONS_COUNT,
        variables() {
          return {
            read: true,
          };
        },
        update({ notification_aggregate }: any) {
          return notification_aggregate.aggregate.count;
        },
      },
      $subscribe: {
        notifications: {
          query: SUBSCRIPTION_GET_NOTIFICATIONS,
          variables() {
            return { read: false, userId: this.currentUserId };
          },
          result({ data }: { data: { notifications: Notification[] } }) {
            if (this.notifications.length === 0) {
              this.notifications = data.notifications;
              return;
            }

            const newNotifications = data.notifications.filter((notification) => {
              const oldNotification = this.notifications.some(
                (notificationShown: Notification) => notificationShown.id === notification.id
              );
              if (oldNotification) {
                return;
              }
              return notification;
            });
            this.notifications = [...newNotifications, ...this.notifications!];
          },
        },
      },
    },
  })
  export default class NotificationsList extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId!: string;

    notifications: Notification[] = [];
    oldNotificationsCount: number = 0;
    processing: boolean = false;

    get isOldNotificationsExist(): boolean {
      return this.oldNotificationsCount > 0;
    }

    get isNoNewNotificationsShown(): boolean {
      return this.notifications.length === 0;
    }

    get isNewNotificationsExist(): boolean {
      return this.notifications.length > 0;
    }

    get isNotificationsExist(): boolean {
      return this.isOldNotificationsExist || this.isNewNotificationsExist;
    }

    get isUnreadNotificationsExist(): boolean {
      return this.notifications.some((notification) => notification.read === false);
    }

    get isMarkAllAsReadDisabled(): boolean {
      return this.processing || !this.isUnreadNotificationsExist
    }

    get noNotificationsContainerStyles(): Object {
      return { notifications__splitter: this.isOldNotificationsExist };
    }

    openAllNotifications(): void {
      this.$emit("close");

      if (this.$route.name === RouteNames.NOTIFICATIONS) {
        this.$eventBus.emit(SHOW_ALL_NOTIFICATIONS);
        return;
      }

      this.$router.push({ name: RouteNames.NOTIFICATIONS });
    }

    removeNotification(id: string): void {
      const updatedNotificationsList = this.notifications.filter((notification) => {
        return notification.id !== id;
      });
      this.notifications = updatedNotificationsList;

      if (updatedNotificationsList.length === 0) {
        this.$emit("close");
      }
    }

    markNotificationsAsRead(): void {
      this.notifications = this.notifications.map((notification) => ({
        ...notification,
        read: true,
      }));
    }

    markOneNotificationAsRead(id: string): void {
      const updatedNotificationsList = this.notifications.map((notification) => {
        if (notification.id === id) {
          notification.read = true;
        }
        return notification;
      });
      this.notifications = updatedNotificationsList;
    }

    // @Watch("notifications")
    // onNotificationsChange(): void {
    //   if (this.notifications) {
    //     this.notifications.forEach((notification) => {
    //       this.$root.$emit('notify', [notification.message, "Unread notifications"]);
    //     });
    //   }
    // }
  }
